import React, {Component} from "react";
import config from 'react-global-configuration';

class CardNumberFilter extends Component {
    state = {
        ci_mask_card_number: 0,
    };
    componentDidMount(){

    }
    resetCardNumberFilter() {
        this.setState({
            ci_mask_card_number: 0,
        })
    }

    handleCheckCardNo(e){
        var ci_mask_card_number  = 1;
        if (e.target.checked === true) {
            this.setState({ci_mask_card_number : 1})
        } else {
            this.setState({ci_mask_card_number : 0});
            ci_mask_card_number  = 0;
        }
        this.props.onSelectCardNumber(ci_mask_card_number);
    }
    render() {
        return (
        <label>
           <input type="checkbox" name="ci_mask_card_number"
           onChange={this.handleCheckCardNo.bind(this)}
           checked={(this.state.ci_mask_card_number == 1) ? true : false}/> &nbsp;  Card Number</label>
        );

    }
}
export default CardNumberFilter;